/* eslint-disable react/no-did-update-set-state */
/* eslint-disable react/no-did-mount-set-state */
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Outlet } from 'react-router-dom'
import _ from 'lodash'
import classnames from 'classnames'
import Helmet from 'react-helmet'
import { subscriptionReselector as stateSelector } from 'reduxModules/auth/selectors'
import { accountMenuDispatcher as dispatcherSelector } from 'reduxModules/auth/dispatchers'
import withRouterV6 from '../../utils/withRouterV6'
import Sidebar from '../generic/Sidebar'
import sidebarItems from './sidebarItems'
import './styles.css'

export class Account extends Component {
  constructor(props) {
    super(props)
    this.state = { sidebarItems }
  }

  componentDidMount() {
    const { canGiftSubscription, getUserInfo } = this.props
    const { sidebarItems } = this.state
    getUserInfo()
    const giftItem = {
      url: '/gift_subscription',
      name: 'Gift Subscription'
    }
    if (canGiftSubscription && !_.find(sidebarItems, giftItem)) {
      const newSidebarItems = this.state.sidebarItems
      newSidebarItems.push(giftItem)
      this.setState({ sidebarItems: newSidebarItems })
    }
  }

  componentDidUpdate(prevProps) {
    const { canGiftSubscription } = this.props
    const { sidebarItems } = this.state
    const giftItem = {
      url: '/gift_subscription',
      name: 'Gift Subscription'
    }
    if (
      !canGiftSubscription &&
      prevProps.canGiftSubscription !== canGiftSubscription
    ) {
      const filteredArray = sidebarItems
      filteredArray.pop()
      this.setState({ sidebarItems: filteredArray })
    }
    if (
      !prevProps.canGiftSubscription &&
      canGiftSubscription &&
      !_.find(sidebarItems, giftItem) &&
      prevProps.canGiftSubscription !== canGiftSubscription
    ) {
      const newSidebarItems = this.state.sidebarItems
      newSidebarItems.push(giftItem)
      this.setState({ sidebarItems: newSidebarItems })
    }
  }

  render() {
    return (
      <div
        id="Account"
        className={classnames({
          'sidenav-wrapper': !this.props.isMobile,
          'topnav-wrapper': this.props.isMobile,
          wrapper: !this.props.isMobile
        })}
      >
        <Helmet>
          <title>Account | Stan Winston School of Character Arts</title>
        </Helmet>
        <div
          className={classnames({
            sidenav: !this.props.isMobile,
            topnav: this.props.isMobile,
            wrapper: !this.props.isMobile
          })}
        >
          <Sidebar
            items={this.state.sidebarItems}
            active={this.props.location.pathname}
            subscription={this.props.subscription}
            isLifetime={this.props.isLifetime}
            name="account"
            isMobile={this.props.isMobile}
            height={this.props.dimensions.height}
          />
        </div>
        <div className="content wrapper">
          {this.props.children || <Outlet />}
        </div>
      </div>
    )
  }
}

Account.propTypes = {
  isLifetime: PropTypes.bool,
  subscription: PropTypes.shape({
    free: PropTypes.bool,
    rank: PropTypes.number,
    plan: PropTypes.string
  }),
  location: PropTypes.shape({
    pathname: PropTypes.string
  })
}

Account.defaultProps = {
  subscription: null,
  location: {
    pathname: ''
  }
}

export default withRouterV6(connect(stateSelector, dispatcherSelector)(Account))
